import { render, staticRenderFns } from "./skypeTool.html?vue&type=template&id=62c20352&scoped=true&"
import script from "./skypeTool.js?vue&type=script&lang=js&"
export * from "./skypeTool.js?vue&type=script&lang=js&"
import style0 from "./skypeTool.scss?vue&type=style&index=0&id=62c20352&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c20352",
  null
  
)

export default component.exports